import {
  CLEAR_ALL,
  GETALL_APIKEYS,
  LOADING_GETALL_APIKEYS,
  PARAMS_APIKEYS,
  SET_ACTIVO_APIKEYS,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  meta: null,
  links: null,
  activo: null,
  params: {
    date: null,
    perMonth: true,
  },
  loadingGetAll: false,
};

export const apiKeysReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_APIKEYS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_ACTIVO_APIKEYS:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_APIKEYS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_APIKEYS:
      return {
        ...state,
        params: action.payload,
      };
    default:
      return state;
  }
};
